

import React, { useState, useEffect } from 'react';
import './Request.css';
import ErrorIcon from "@mui/icons-material/Error";
// import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close'
import EastIcon from "@mui/icons-material/East";
import ClearIcon from '@mui/icons-material/Clear';
import { X, Upload, FileText, Image, Video, Music, Archive, ChevronDown } from 'lucide-react';
import { Box } from "@mui/material";
import axios from "axios";
import EditDocumentIcon from '@mui/icons-material/EditDocument';

const API_BASE_URL = 'https://api.waraq.co/waraq/api/v1';

const INITIAL_FORM_DATA = {
    managerId: 0,
    requestDate: new Date().toISOString(),
    studentName: '',
    totalPages: "",
    deliveryDate: '2025-09-07T09:43:12.836Z',
    clientId: '',
    taskTitle: ''
};

const INITIAL_SELECTED_VALUES = {
    "Client": "",
    "Translator": "",
    "Proofreader": "",
    "Status": ""
};

const FILTER_TYPES = ["Client", "Translator", "Proofreader", "Status"];

const STATUS_STYLES = {
    'UNASSIGNED': { backgroundColor: '#ff6b6b', color: '#FFF' },
    'TRANSLATING': { backgroundColor: '#51cf66', color: '#FFF' },
    'PROOFREADING': { backgroundColor: '#9775fa', color: '#FFF' }
};

const getAuthHeaders = () => ({
    Authorization: `${localStorage.getItem("jwtToken")}`
});

const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

const getFileIcon = (file) => {
    const type = file.type;
    const iconProps = { className: "file-icon" };

    if (type.includes('image')) return <Image {...iconProps} className="file-icon file-icon-image" />;
    if (type.includes('video')) return <Video {...iconProps} className="file-icon file-icon-video" />;
    if (type.includes('audio')) return <Music {...iconProps} className="file-icon file-icon-audio" />;
    if (type.includes('pdf') || type.includes('document')) return <FileText {...iconProps} className="file-icon file-icon-document" />;
    if (type.includes('zip') || type.includes('rar')) return <Archive {...iconProps} className="file-icon file-icon-archive" />;
    return <FileText {...iconProps} className="file-icon file-icon-default" />;
};


const TASK_STATUS_STYLES = {
    UNASSIGNED: { backgroundColor: '#FF7777', color: '#000' },
    TRANSLATING: { backgroundColor: '#55D55B', color: '#000' },
    PROOFREADING: { backgroundColor: '#B991FF', color: '#000' },
    STAMPING: { backgroundColor: '#FFCD50', color: '#000' },
    COMPLETED: { backgroundColor: '#C7DDFF', color: '#000' },
};

const getStatusStyle = (status) => ({
    padding: '6px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: '500',
    display: 'inline-block',
    textAlign: 'center',
    ...(TASK_STATUS_STYLES[status] || { backgroundColor: '#dee2e6', color: '#333' }),
});


const useAPI = () => {
    const getAllAdmin = async () => {
        const res = await axios.get(`${API_BASE_URL}/admin/users?role=TRANSLATOR`, { headers: getAuthHeaders() });
        return res.data.data;
    };

    const getAllClients = async () => {
        const res = await axios.get(`${API_BASE_URL}/admin/users?role=CLIENT`, { headers: getAuthHeaders() });
        return res.data.data;
    };

    const getAllRequest = async () => {
        const res = await axios.get(`${API_BASE_URL}/admin/translate/requests`, { headers: getAuthHeaders() });
        return res.data.data;
    };

    const submitRequest = async (requestData) => {
        const res = await axios.post(`${API_BASE_URL}/translate/requests`, requestData, { headers: getAuthHeaders() });
        return res.data;
    };

    return { getAllAdmin, getAllClients, getAllRequest, submitRequest };
};

const useDownload = () => {
    const handleDownload = async (mediaId, name) => {
        console.log('handleDownload' , name);
        let splitFileName = name.split('.com/')[1];
        console.log('splitFileName' , splitFileName);
        try {
            const url = `${API_BASE_URL}/media/download/${mediaId}`;
            const response = await axios.get(url, {
                headers: getAuthHeaders(),
                responseType: "blob",
            });

            const blob = response.data;
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;

            const contentDisposition = response.headers["content-disposition"];
            let fileName = splitFileName;

            if (contentDisposition) {
                const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match?.[1]) {
                    fileName = match[1].replace(/['"]/g, "");
                }
            }

            if (!fileName.includes(".")) {
                const contentType = response.headers["content-type"];
                const ext = contentType?.split("/")[1] || "bin";
                fileName = `${fileName}.${ext}`;
            }

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    return { handleDownload };
};

const ConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
    if (!isOpen) return null;

    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
        }}>
            <div style={{
                background: "#FFF",
                padding: "20px",
                borderRadius: "8px",
                width: "400px",
                textAlign: "center",
            }}>
                <p style={{ marginBottom: "20px" }}>{message}</p>
                <div style={{
                    display: "flex",
                    gap: "20px",
                    justifyContent: "flex-end",
                }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: "8px 16px",
                            border: "none",
                            borderRadius: "4px",
                            background: "#ccc",
                            cursor: "pointer",
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        style={{
                            padding: "8px 16px",
                            border: "none",
                            borderRadius: "4px",
                            background: "red",
                            color: "white",
                            cursor: "pointer",
                        }}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

const FilterDropdown = ({ filter, selectedValue, options, isOpen, onClick, onSelect }) => (
    <div className="filter-box" onClick={() => onClick(filter)}>
        <span className="filter-label">
            {selectedValue || filter}
        </span>
        <ChevronDown className={`filter-icon ${isOpen ? 'rotated' : ''}`} />

        {isOpen && (
            <div className="dropdown-menu">
                <div
                    className="dropdown-option"
                    onClick={(e) => {
                        e.stopPropagation();
                        onSelect(filter, "");
                    }}
                >
                    Clear Selection
                </div>
                {options.map((option, optionIndex) => (
                    <div
                        key={optionIndex}
                        className="dropdown-option"
                        onClick={(e) => {
                            e.stopPropagation();
                            onSelect(filter, option);
                        }}
                    >
                        {option}
                    </div>
                ))}
            </div>
        )}
    </div>
);

const FileUpload = ({ files, onFileChange, onRemoveFile }) => {
    const [hoveredItem, setHoveredItem] = useState(null);
    const [hoveredButton, setHoveredButton] = useState(null);

    const styles = {
        container: {
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
        },
        fileItem: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px',
            backgroundColor: '#f9fafb',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            marginBottom: '8px',
            transition: 'all 0.15s ease-in-out',
            cursor: 'default'
        },
        fileItemHover: {
            backgroundColor: '#f3f4f6'
        },
        fileContent: {
            display: 'flex',
            alignItems: 'center',
            flex: '1',
            minWidth: '0',
            gap: '12px'
        },
        fileDetails: {
            flex: '1',
            minWidth: '0'
        },
        fileName: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#111827',
            margin: '0 0 4px 0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        fileSize: {
            fontSize: '12px',
            color: '#6b7280',
            margin: '0'
        },
        removeButton: {
            marginLeft: '12px',
            padding: '8px',
            color: '#ef4444',
            backgroundColor: 'transparent',
            border: 'none',
            borderRadius: '50%',
            cursor: 'pointer',
            transition: 'all 0.15s ease-in-out',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: '0'
        },
        removeButtonHover: {
            color: '#dc2626',
            backgroundColor: '#fef2f2'
        }
    };

    return (
        <>
            <div style={{
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '20px'
            }}>
                <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                    <div style={{
                        border: '2px dashed #d1d5db',
                        borderRadius: '8px',
                        padding: '32px',
                        textAlign: 'center',
                        transition: 'all 0.2s ease',
                        backgroundColor: 'white'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: '16px'
                        }}>
                            <Upload />
                        </div>
                        <p style={{ textAlign: 'center', margin: '8px 0' }}>
                            Click to upload files
                        </p>
                        <p style={{ textAlign: 'center', margin: '8px 0' }}>
                            Select multiple files to upload
                        </p>
                    </div>
                </label>

                <input
                    id="file-upload"
                    type="file"
                    multiple
                    style={{ display: "none" }}
                    onChange={onFileChange}
                />
            </div>

            <div style={styles.container}>
                <h3 style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#374151',
                    marginBottom: '8px'
                }}>
                    Uploaded Files ({files.length})
                </h3>

                {files.map((file, index) => (
                    <div
                        key={index}
                        style={{
                            ...styles.fileItem,
                            ...(hoveredItem === index ? styles.fileItemHover : {})
                        }}
                        onMouseEnter={() => setHoveredItem(index)}
                        onMouseLeave={() => setHoveredItem(null)}
                    >
                        <div style={styles.fileContent}>
                            {getFileIcon(file)}
                            <div style={styles.fileDetails}>
                                <p style={styles.fileName}>{file.name}</p>
                                <p style={styles.fileSize}>{formatFileSize(file.size)}</p>
                            </div>
                        </div>

                        <button
                            onClick={() => onRemoveFile(index)}
                            style={{
                                ...styles.removeButton,
                                ...(hoveredButton === index ? styles.removeButtonHover : {})
                            }}
                            onMouseEnter={() => setHoveredButton(index)}
                            onMouseLeave={() => setHoveredButton(null)}
                            title="Remove file"
                        >
                            <X style={{ width: '16px', height: '16px' }} />
                        </button>
                    </div>
                ))}
            </div>
        </>
    );
};

const DocumentTable = ({ documents, handleDownload, onDeleteSuccess }) => {
    const [showDialog, setShowDialog] = useState(false);
    const [selectedDocId, setSelectedDocId] = useState(null);

    const deleteDoc = async (docId) => {
        try {
            await axios.delete(
                `${API_BASE_URL}/translate/docs/${docId}`,
                { headers: getAuthHeaders() }
            );
            onDeleteSuccess?.();
        } catch (err) {
            console.error('Error deleting document:', err);
        } finally {
            setShowDialog(false);
            setSelectedDocId(null);
        }
    };

    const handleDeleteClick = (docId) => {
        setSelectedDocId(docId);
        setShowDialog(true);
    };

    const handleConfirmDelete = () => {
        if (selectedDocId) {
            deleteDoc(selectedDocId);
        }
    };

    const handleCancelDelete = () => {
        setShowDialog(false);
        setSelectedDocId(null);
    };

    return (
        <>
            <table className="styled-table" style={{ marginTop: "10px", width: "100%" }}>
                <thead className="styled-thead">
                    <tr>
                        <th style={{ fontWeight: "500", color: "#000", fontSize: "14px" }}>Document (PDF)</th>
                        <th style={{ fontWeight: "500", color: "#000", fontSize: "14px" }}>Template (Word)</th>
                        <th style={{ fontWeight: "500", color: "#000", fontSize: "14px" }}>Translation (Word)</th>
                        <th style={{ fontWeight: "500", color: "#000", fontSize: "14px" }}>Delivery (Word)</th>
                        <th style={{ fontWeight: "500", color: "#000", fontSize: "14px" }}>Created At</th>
                        <th style={{ fontWeight: "500", color: "#000", fontSize: "14px" }}>Action</th>
                    </tr>
                </thead>

                <tbody className="styled-tbody">
                    {documents.map((row, idx) => (
                        <tr className="styled-row" key={idx}>
                            <td className="styled-cell">
                                <a
                                    onClick={() => { handleDownload(row.documentId, row.document) }}
                                    style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                >
                                    {row?.document.split('.com/')[1]?.length > 25
                                        ? row?.document.split('.com/')[1].slice(0, 25) + '...'
                                        : row?.document.split('.com/')[1]}

                                </a>
                            </td>

                            <td className="styled-cell">
                                {row.templateUrl ? (
                                    <a
                                        onClick={() => { handleDownload(row.templateId, row.templateUrl) }}
                                        rel="noopener noreferrer"
                                        style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                    >
                                        {row?.templateUrl.split('.com/')[1]?.length > 25
                                            ? row?.templateUrl.split('.com/')[1].slice(0, 25) + '...'
                                            : row?.templateUrl.split('.com/')[1]}
                                    </a>
                                ) : (
                                    "No file uploaded"
                                )}
                            </td>

                            <td className="styled-cell">
                                {row.translatedDocumentUrl ? (
                                    <a
                                        onClick={() => { handleDownload(row.translatedDocumentId, row.translatedDocumentUrl) }}
                                        rel="noopener noreferrer"
                                        style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                    >
                                        {row?.translatedDocumentUrl.split('.com/')[1]?.length > 25
                                            ? row?.translatedDocumentUrl.split('.com/')[1].slice(0, 25) + '...'
                                            : row?.translatedDocumentUrl.split('.com/')[1]}

                                    </a>
                                ) : (
                                    "No file uploaded"
                                )}
                            </td>

                            <td className="styled-cell">
                                {row.finalTranslatedDocumentUrl ? (
                                    <a
                                        onClick={() => { handleDownload(row.finalTranslatedDocumentId, row.finalTranslatedDocumentUrl) }}
                                        rel="noopener noreferrer"
                                        style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}>


                                        {row?.finalTranslatedDocumentUrl.split('.com/')[1]?.length > 25
                                            ? row?.finalTranslatedDocumentUrl.split('.com/')[1].slice(0, 25) + '...'
                                            : row?.finalTranslatedDocumentUrl.split('.com/')[1]}
                                    </a>
                                ) : (
                                    "No file uploaded"
                                )}
                            </td>

                            <td className="styled-cell">{row?.creationDate?.substring(0, 10) || "—"}</td>

                            <td className="styled-cell">
                                <ClearIcon
                                    onClick={() => { handleDeleteClick(row.id) }}
                                    style={{ color: "red", cursor: "pointer" }}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <ConfirmationModal
                isOpen={showDialog}
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
                message="Are you sure you want to delete this document?"
            />
        </>
    );
};


// const TaskCard = ({ task, onDelete, onUpdate }) => {
//     const [openRequests, setOpenRequests] = useState({});
//     const [currentOpenRequestId, setCurrentOpenRequestId] = useState(null);
//     const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [editFormData, setEditFormData] = useState({
//         totalPages: '',
//         taskTitle: '',
//         deliveryDate: '',
//         requestDate: ''
//     });
//     const [formErrors, setFormErrors] = useState({});
//     const { handleDownload } = useDownload();

//     const handleDeleteClick = (e) => {
//         e.stopPropagation();
//         setShowDeleteConfirm(true);
//     };

//     const handleEditClick = (e) => {
//         e.stopPropagation();
//         // Populate form with existing values
//         setEditFormData({
//             totalPages: task.totalPages || '',
//             taskTitle: task.taskTitle || '',
//             deliveryDate: task.deliveryDate ? task.deliveryDate: '',
//             requestDate: task.requestDate ?  task.requestData : ''


//             //             const requestDateObj = new Date(editFormData.requestDate + 'T00:00:00');
//             // const deliveryDateObj = new Date(editFormData.deliveryDate + 'T00:00:00');


//         });
//         setFormErrors({});
//         setShowEditModal(true);
//     };

//     const validateForm = () => {
//         const errors = {};

//         if (!editFormData.totalPages || editFormData.totalPages === '') {
//             errors.totalPages = 'Total Pages is required';
//         }

//         if (!editFormData.taskTitle || editFormData.taskTitle.trim() === '') {
//             errors.taskTitle = 'Task Title is required';
//         }

//         if (!editFormData.deliveryDate || editFormData.deliveryDate.trim() === '') {
//             errors.deliveryDate = 'Delivery Date is required';
//         }

//         if (!editFormData.requestDate || editFormData.requestDate.trim() === '') {
//             errors.requestDate = 'Request Date is required';
//         }

//         return errors;
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setEditFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//         // Clear error for this field when user starts typing
//         if (formErrors[name]) {
//             setFormErrors(prev => ({
//                 ...prev,
//                 [name]: ''
//             }));
//         }
//     };

//     const handleUpdateSubmit = async () => {
//         const errors = validateForm();

//         if (Object.keys(errors).length > 0) {
//             setFormErrors(errors);
//             return;
//         }

//         try {
//             // Format dates to match backend requirements without timezone shift
//             const requestDateObj = new Date(editFormData.requestDate + 'T00:00:00');
//             const deliveryDateObj = new Date(editFormData.deliveryDate + 'T00:00:00');

//             const formattedData = {
//                 ...editFormData,
//                 requestDate: requestDateObj.toISOString(),
//                 deliveryDate: deliveryDateObj.toISOString()
//             };

//             console.log('old data' , editFormData);

//             console.log('formattedData' , formattedData);

//             // await axios.put(
//             //     `${API_BASE_URL}/translate/requests/${task.id}`,
//             //     formattedData,
//             //     { headers: getAuthHeaders() }
//             // );
//             // setShowEditModal(false);
//             // onUpdate?.(); 
//         } catch (err) {
//             console.error("Error updating request:", err);
//         }
//     };

//     const confirmDelete = async () => {
//         try {
//             await axios.delete(`${API_BASE_URL}/translate/requests/${task.id}`, {
//                 headers: getAuthHeaders()
//             });
//             setShowDeleteConfirm(false);
//             onDelete?.();
//         } catch (err) {
//             console.error("Error deleting request:", err);
//         }
//     };

//     const getDocByRequestID = async (id, shouldToggle = true) => {
//         try {
//             const res = await axios.get(
//                 `${API_BASE_URL}/translate/docs?requestId=${id}`,
//                 { headers: getAuthHeaders() }
//             );

//             const mappedDocs = res.data.data.map((doc) => ({
//                 id: doc.id,
//                 document: doc.documentUrl,
//                 documentId: doc.documentId,
//                 finalTranslatedDocumentId: doc.finalTranslatedDocumentId,
//                 finalTranslatedDocumentUrl: doc.finalTranslatedDocumentUrl,
//                 templateUrl: doc.templateUrl,
//                 templateId: doc.templateId,
//                 translatedDocumentId: doc.translatedDocumentId,
//                 translatedDocumentUrl: doc.translatedDocumentUrl,
//                 creationDate: doc.creationDate,
//             }));

//             setOpenRequests((prev) => ({
//                 ...prev,
//                 [id]: mappedDocs,
//             }));

//             if (shouldToggle) {
//                 setCurrentOpenRequestId((prevId) => 
//                     prevId === id ? null : id
//                 );
//             }
//         } catch (error) {
//             console.error("Error fetching documents:", error);
//         }
//     };

//     const handleDocumentDelete = () => {
//         getDocByRequestID(task.id, false);
//     };

//     const taskFields = [
//         { label: '#ID', value: task.id, flex: '1 1 10px' },
//         { label: 'Client Name', value: task.clientName, flex: '1 1 50px' },
//         { label: 'Request Date', value: new Date(task.requestDate).toLocaleDateString(), flex: '1 1 50px' },
//         { label: 'Task Title', value: task.taskTitle || 'n/a', flex: '1 1 50px' },
//         { label: 'Total Pages', value: task.totalPages, flex: '1 1 50px' },
//         { label: 'Translator', value: task.translatorName || "N/A", flex: '1 1 50px' },
//         { label: 'Proofreader', value: task.proofreaderName || "N/A", flex: '1 1 50px' },
//         { label: 'Delivery Date', value: new Date(task.deliveryDate).toLocaleDateString(), flex: '1 1 50px' }
//     ];

//     return (
//         <>
//             <div className="task-card">
//                 <div
//                     style={{
//                         cursor: "pointer",
//                         display: 'flex',
//                         flexWrap: 'wrap',
//                         gap: '10px'
//                     }}
//                     className="task-row"
//                     onClick={() => getDocByRequestID(task.id, true)}
//                 >
//                     {taskFields.map((field, index) => (
//                         <div key={index} style={{ flex: field.flex, minWidth: '50px' }}>
//                             <strong style={{ fontSize: "14px" }}>{field.label}</strong>
//                             <br />
//                             {field.value}
//                         </div>
//                     ))}

//                     <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
//                         <strong style={{ fontSize: "14px" }}>Status</strong>
//                         <br />
//                         <span style={getStatusStyle(task.status)}>{task.status}</span>
//                     </div>

//                     <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
//                         <strong style={{ fontSize: "14px" }}>Action</strong>
//                         <br />
//                         <ClearIcon
//                             style={{ cursor: "pointer", color: "red" }}
//                             onClick={handleDeleteClick}
//                         />
//                     </div>

//                     <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
//                         <strong style={{ fontSize: "14px" }}>Update</strong>
//                         <br />
//                         <EditIcon
//                             style={{ cursor: "pointer", color: "#333" }}
//                             onClick={handleEditClick}
//                         />
//                     </div>
//                 </div>
//             </div>

//             {currentOpenRequestId === task.id && openRequests[task.id] && (
//                 <DocumentTable
//                     documents={openRequests[task.id]}
//                     handleDownload={handleDownload}
//                     onDeleteSuccess={handleDocumentDelete}
//                 />
//             )}

//             <ConfirmationModal
//                 isOpen={showDeleteConfirm}
//                 onClose={() => setShowDeleteConfirm(false)}
//                 onConfirm={confirmDelete}
//                 message="Are you sure you want to delete this request?"
//             />

//             {/* Edit Modal */}
//             {showEditModal && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     zIndex: 1000
//                 }}>
//                     <div style={{
//                         backgroundColor: 'white',
//                         borderRadius: '8px',
//                         padding: '24px',
//                         width: '90%',
//                         maxWidth: '500px',
//                         position: 'relative',
//                         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//                     }}>
//                         <div style={{
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'center',
//                             marginBottom: '20px'
//                         }}>
//                             <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
//                                 Edit Request
//                             </h2>
//                             <CloseIcon
//                                 onClick={() => setShowEditModal(false)}
//                                 style={{ cursor: 'pointer', color: '#666' }}
//                             />
//                         </div>

//                         <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                             <div>
//                                 <label style={{ 
//                                     display: 'block', 
//                                     marginBottom: '8px',
//                                     fontWeight: '500',
//                                     fontSize: '14px'
//                                 }}>
//                                     Total Pages *
//                                 </label>
//                                 <input
//                                     type="number"
//                                     name="totalPages"
//                                     value={editFormData.totalPages}
//                                     onChange={handleInputChange}
//                                     style={{
//                                         width: '100%',
//                                         padding: '10px',
//                                         border: formErrors.totalPages ? '1px solid red' : '1px solid #ddd',
//                                         borderRadius: '4px',
//                                         fontSize: '14px',
//                                         boxSizing: 'border-box'
//                                     }}
//                                 />
//                                 {formErrors.totalPages && (
//                                     <span style={{ color: 'red', fontSize: '12px', marginTop: '4px', display: 'block' }}>
//                                         {formErrors.totalPages}
//                                     </span>
//                                 )}
//                             </div>

//                             <div>
//                                 <label style={{ 
//                                     display: 'block', 
//                                     marginBottom: '8px',
//                                     fontWeight: '500',
//                                     fontSize: '14px'
//                                 }}>
//                                     Task Title *
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="taskTitle"
//                                     value={editFormData.taskTitle}
//                                     onChange={handleInputChange}
//                                     style={{
//                                         width: '100%',
//                                         padding: '10px',
//                                         border: formErrors.taskTitle ? '1px solid red' : '1px solid #ddd',
//                                         borderRadius: '4px',
//                                         fontSize: '14px',
//                                         boxSizing: 'border-box'
//                                     }}
//                                 />
//                                 {formErrors.taskTitle && (
//                                     <span style={{ color: 'red', fontSize: '12px', marginTop: '4px', display: 'block' }}>
//                                         {formErrors.taskTitle}
//                                     </span>
//                                 )}
//                             </div>

//                             <div>
//                                 <label style={{ 
//                                     display: 'block', 
//                                     marginBottom: '8px',
//                                     fontWeight: '500',
//                                     fontSize: '14px'
//                                 }}>
//                                     Delivery Date *
//                                 </label>
//                                 <input
//                                     type="date"
//                                     name="deliveryDate"
//                                     value={editFormData.deliveryDate}
//                                     onChange={handleInputChange}
//                                     style={{
//                                         width: '100%',
//                                         padding: '10px',
//                                         border: formErrors.deliveryDate ? '1px solid red' : '1px solid #ddd',
//                                         borderRadius: '4px',
//                                         fontSize: '14px',
//                                         boxSizing: 'border-box'
//                                     }}
//                                 />
//                                 {formErrors.deliveryDate && (
//                                     <span style={{ color: 'red', fontSize: '12px', marginTop: '4px', display: 'block' }}>
//                                         {formErrors.deliveryDate}
//                                     </span>
//                                 )}
//                             </div>

//                             <div>
//                                 <label style={{ 
//                                     display: 'block', 
//                                     marginBottom: '8px',
//                                     fontWeight: '500',
//                                     fontSize: '14px'
//                                 }}>
//                                     Request Date *
//                                 </label>
//                                 <input
//                                     type="date"
//                                     name="requestDate"
//                                     value={editFormData.requestDate}
//                                     onChange={handleInputChange}
//                                     style={{
//                                         width: '100%',
//                                         padding: '10px',
//                                         border: formErrors.requestDate ? '1px solid red' : '1px solid #ddd',
//                                         borderRadius: '4px',
//                                         fontSize: '14px',
//                                         boxSizing: 'border-box'
//                                     }}
//                                 />
//                                 {formErrors.requestDate && (
//                                     <span style={{ color: 'red', fontSize: '12px', marginTop: '4px', display: 'block' }}>
//                                         {formErrors.requestDate}
//                                     </span>
//                                 )}
//                             </div>
//                         </div>

//                         <div style={{
//                             display: 'flex',
//                             justifyContent: 'flex-end',
//                             gap: '12px',
//                             marginTop: '24px'
//                         }}>
//                             <button
//                                 onClick={() => setShowEditModal(false)}
//                                 style={{
//                                     padding: '10px 20px',
//                                     border: '1px solid #ddd',
//                                     borderRadius: '4px',
//                                     backgroundColor: 'white',
//                                     cursor: 'pointer',
//                                     fontSize: '14px',
//                                     fontWeight: '500'
//                                 }}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleUpdateSubmit}
//                                 style={{
//                                     padding: '10px 20px',
//                                     border: 'none',
//                                     borderRadius: '4px',
//                                     backgroundColor: '#007bff',
//                                     color: 'white',
//                                     cursor: 'pointer',
//                                     fontSize: '14px',
//                                     fontWeight: '500'
//                                 }}
//                             >
//                                 Update
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

const TaskCard = ({ task, onDelete, onUpdate }) => {
    const [openRequests, setOpenRequests] = useState({});
    const [currentOpenRequestId, setCurrentOpenRequestId] = useState(null);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('')
    const [editFormData, setEditFormData] = useState({
        totalPages: '',
        taskTitle: ''
    });
    const [formErrors, setFormErrors] = useState({});
    const { handleDownload } = useDownload();

    const handleDeleteClick = (e) => {
        e.stopPropagation();
        setShowDeleteConfirm(true);
    };

    const handleEditClick = (e) => {
        e.stopPropagation();
        setEditFormData({
            totalPages: task.totalPages || '',
            taskTitle: task.taskTitle || '',
        });

        console.log('handleEditClick', editFormData);
        setFormErrors({});
        setShowEditModal(true);
    };

    const validateForm = () => {
        const errors = {};

        if (!editFormData.totalPages || editFormData.totalPages === '') {
            errors.totalPages = 'Total Pages is required';
        }

        if (!editFormData.taskTitle || editFormData.taskTitle.trim() === '') {
            errors.taskTitle = 'Task Title is required';
        }

        return errors;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (formErrors[name]) {
            setFormErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleUpdateSubmit = async () => {
        const errors = validateForm();

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        try {
            await axios.put(
                `${API_BASE_URL}/translate/requests/${task.id}`,
                editFormData,
                { headers: getAuthHeaders() }
            );
            setShowEditModal(false);
            setSuccessMessage('Update Request Successfully');
            setTimeout(() => {
                setSuccessMessage('');
            }, 3000);
            onUpdate?.();
        } catch (err) {
            console.error("Error updating request:", err);
        }
    };

    const confirmDelete = async () => {
        try {
            await axios.delete(`${API_BASE_URL}/translate/requests/${task.id}`, {
                headers: getAuthHeaders()
            });
            setShowDeleteConfirm(false);
            onDelete?.();
        } catch (err) {
            console.error("Error deleting request:", err);
        }
    };

    const getDocByRequestID = async (id, shouldToggle = true) => {
        try {
            const res = await axios.get(
                `${API_BASE_URL}/translate/docs?requestId=${id}`,
                { headers: getAuthHeaders() }
            );

            const mappedDocs = res.data.data.map((doc) => ({
                id: doc.id,
                document: doc.documentUrl,
                documentId: doc.documentId,
                finalTranslatedDocumentId: doc.finalTranslatedDocumentId,
                finalTranslatedDocumentUrl: doc.finalTranslatedDocumentUrl,
                templateUrl: doc.templateUrl,
                templateId: doc.templateId,
                translatedDocumentId: doc.translatedDocumentId,
                translatedDocumentUrl: doc.translatedDocumentUrl,
                creationDate: doc.creationDate,
            }));

            setOpenRequests((prev) => ({
                ...prev,
                [id]: mappedDocs,
            }));

            if (shouldToggle) {
                setCurrentOpenRequestId((prevId) =>
                    prevId === id ? null : id
                );
            }
        } catch (error) {
            console.error("Error fetching documents:", error);
        }
    };

    const handleDocumentDelete = () => {
        getDocByRequestID(task.id, false);
    };

    const taskFields = [
        { label: '#ID', value: task.id, flex: '1 1 10px' },
        { label: 'Client Name', value: task.clientName, flex: '1 1 50px' },
        { label: 'Request Date', value: new Date(task.requestDate).toLocaleDateString(), flex: '1 1 50px' },
        { label: 'Task Title', value: task.taskTitle || 'n/a', flex: '1 1 50px' },
        { label: 'Total Pages', value: task.totalPages, flex: '1 1 50px' },
        { label: 'Translator', value: task.translatorName || "N/A", flex: '1 1 50px' },
        { label: 'Proofreader', value: task.proofreaderName || "N/A", flex: '1 1 50px' },
        { label: 'Delivery Date', value: new Date(task.deliveryDate).toLocaleDateString(), flex: '1 1 50px' }
    ];

    return (
        <>
            <div className="task-card">
                <div
                    style={{
                        cursor: "pointer",
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '10px'
                    }}
                    className="task-row"
                    onClick={() => getDocByRequestID(task.id, true)}
                >
                    {taskFields.map((field, index) => (
                        <div key={index} style={{ flex: field.flex, minWidth: '50px' }}>
                            <strong style={{ fontSize: "14px" }}>{field.label}</strong>
                            <br />
                            {field.value}
                        </div>
                    ))}

                    <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                        <strong style={{ fontSize: "14px" }}>Status</strong>
                        <br />
                        <span style={getStatusStyle(task.status)}>{task.status}</span>
                    </div>

                    <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                        <strong style={{ fontSize: "14px" }}>Action</strong>
                        <br />
                        <ClearIcon
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={handleDeleteClick}
                        />
                    </div>

                    <div style={{ flex: '1 1 50px', minWidth: '50px' }}>
                        <strong style={{ fontSize: "14px" }}>Update</strong>
                        <br />
                        <EditIcon
                            style={{ cursor: "pointer", color: "#333" }}
                            onClick={handleEditClick}
                        />
                    </div>
                </div>
            </div>

            {currentOpenRequestId === task.id && openRequests[task.id] && (
                <DocumentTable
                    documents={openRequests[task.id]}
                    handleDownload={handleDownload}
                    onDeleteSuccess={handleDocumentDelete}
                />
            )}

            <ConfirmationModal
                isOpen={showDeleteConfirm}
                onClose={() => setShowDeleteConfirm(false)}
                onConfirm={confirmDelete}
                message="Are you sure you want to delete this request?"
            />

            {showEditModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        padding: '24px',
                        width: '90%',
                        maxWidth: '500px',
                        position: 'relative',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px'
                        }}>
                            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
                                Edit Request
                            </h2>
                            <CloseIcon
                                onClick={() => setShowEditModal(false)}
                                style={{ cursor: 'pointer', color: '#666' }}
                            />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: '500',
                                    fontSize: '14px'
                                }}>
                                    Total Pages *
                                </label>
                                <input
                                    type="number"
                                    name="totalPages"
                                    value={editFormData.totalPages}
                                    onChange={handleInputChange}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        border: formErrors.totalPages ? '1px solid red' : '1px solid #ddd',
                                        borderRadius: '4px',
                                        fontSize: '14px',
                                        boxSizing: 'border-box'
                                    }}
                                />
                                {formErrors.totalPages && (
                                    <span style={{ color: 'red', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                                        {formErrors.totalPages}
                                    </span>
                                )}
                            </div>

                            <div>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '8px',
                                    fontWeight: '500',
                                    fontSize: '14px'
                                }}>
                                    Task Title *
                                </label>
                                <input
                                    type="text"
                                    name="taskTitle"
                                    value={editFormData.taskTitle}
                                    onChange={handleInputChange}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        border: formErrors.taskTitle ? '1px solid red' : '1px solid #ddd',
                                        borderRadius: '4px',
                                        fontSize: '14px',
                                        boxSizing: 'border-box'
                                    }}
                                />
                                {formErrors.taskTitle && (
                                    <span style={{ color: 'red', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                                        {formErrors.taskTitle}
                                    </span>
                                )}
                            </div>






                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '12px',
                            marginTop: '24px'
                        }}>
                            <button
                                onClick={() => setShowEditModal(false)}
                                style={{
                                    padding: '10px 20px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    backgroundColor: 'white',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleUpdateSubmit}
                                style={{
                                    padding: '10px 20px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    backgroundColor: '#3F302F',
                                    color: 'white',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            )}



            {successMessage && (
                <div className="popup-message">
                    {successMessage}
                </div>
            )}
        </>
    );
};


const NewRequestModal = ({
    isOpen,
    onClose,
    formData,
    onFormChange,
    clients,
    admin,
    files,
    onFileChange,
    onRemoveFile,
    onSubmit,
    errors,
    loading,
}) => {
    if (!isOpen) return null;

    const inputStyle = {
        width: '100%',
        padding: '12px',
        border: '1px solid #d1d5db',
        borderRadius: '8px',
        fontSize: '14px',
        transition: 'border-color 0.2s, box-shadow 0.2s'
    };

    const handleFocus = (e) => {
        e.target.style.borderColor = '#3b82f6';
        e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
    };

    const handleBlur = (e) => {
        e.target.style.borderColor = '#d1d5db';
        e.target.style.boxShadow = 'none';
    };

    const formFields = [
        {
            type: 'select',
            label: 'Select Client',
            value: formData.clientId,
            onChange: (e) => onFormChange({ ...formData, clientId: e.target.value }),
            options: clients.map(user => ({ value: user.id, label: `${user.firstName} ${user.lastName}` })),
            error: errors.client
        },
        {
            type: 'select',
            label: 'Select Manager',
            value: formData.managerId,
            onChange: (e) => onFormChange({ ...formData, managerId: e.target.value }),
            options: admin.map(adminUser => ({ value: adminUser.id, label: `${adminUser.firstName} ${adminUser.lastName}` })),
            error: errors.managerId
        },
        {
            type: 'date',
            label: 'Request Date',
            value: formData.requestDate,
            onChange: (e) => onFormChange({ ...formData, requestDate: e.target.value })
        },
        {
            type: 'text',
            placeholder: 'task title',
            value: formData.taskTitle,
            onChange: (e) => onFormChange({ ...formData, taskTitle: e.target.value }),
            error: errors.taskTitle
        },
        {
            type: 'date',
            label: 'Delivery Date',
            value: formData.deliveryDate,
            onChange: (e) => onFormChange({ ...formData, deliveryDate: e.target.value })
        },
        {
            type: 'number',
            placeholder: 'Total Pages',
            value: formData.totalPages,
            onChange: (e) => onFormChange({ ...formData, totalPages: e.target.value }),
            error: errors.totalPages
        }
    ];

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 50,
            padding: '16px'
        }}>
            <div style={{
                backgroundColor: '#FFF',
                borderRadius: '8px',
                width: '100%',
                maxWidth: '500px',
                maxHeight: '80vh',
                overflowY: 'auto'
            }}>
                <div style={{ padding: '24px' }}>
                    <h2 style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        marginBottom: '24px',
                        color: '#1f2937'
                    }}>
                        New Request
                    </h2>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {formFields.map((field, index) => (
                            <div key={index}>
                                {field.label && (
                                    <label style={{
                                        display: 'block',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#374151',
                                        marginBottom: '8px'
                                    }}>
                                        {field.label}
                                    </label>
                                )}

                                {field.type === 'select' ? (
                                    <select
                                        value={field.value}
                                        onChange={field.onChange}
                                        style={inputStyle}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                    >
                                        <option value="">{field.label}</option>
                                        {field.options.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                ) : (
                                    <input
                                        type={field.type}
                                        value={field.value}
                                        onChange={field.onChange}
                                        placeholder={field.placeholder}
                                        style={inputStyle}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                    />
                                )}

                                {field.error && (
                                    <p style={{ color: '#ef4444', fontSize: '14px', marginTop: '4px' }}>
                                        <ErrorIcon style={{ fontSize: "14px", marginTop: '10px', marginRight: "5px" }} />
                                        {field.error}
                                    </p>
                                )}
                            </div>
                        ))}

                        <FileUpload
                            files={files}
                            onFileChange={onFileChange}
                            onRemoveFile={onRemoveFile}
                        />

                        {errors.files && (
                            <p style={{ color: '#ef4444', fontSize: '14px', marginTop: '4px' }}>
                                <ErrorIcon style={{ fontSize: "14px", marginTop: '0px', marginRight: "5px" }} />
                                {errors.files}
                            </p>
                        )}
                    </div>

                    <div className="dialog-actions">
                        <button type="button" onClick={onClose} className="btn cancel">Cancel</button>
                        <button
                            onClick={onSubmit}
                            className="btn send"
                            disabled={loading}
                        >
                            {loading ? 'Adding...' : 'Add'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const Request = () => {
    const [tasks, setTasks] = useState([]);
    const [admin, setAdmin] = useState([]);
    const [clients, setClients] = useState([]);
    const [files, setFiles] = useState([]);
    const [open, setOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState(INITIAL_FORM_DATA);
    const [openFilter, setOpenFilter] = useState(null);
    const [selectedValues, setSelectedValues] = useState(INITIAL_SELECTED_VALUES);
    const [successMessage, setSuccessMessage] = useState(null);
    const [loading, setLoading] = useState(false);

    const { getAllAdmin, getAllClients, getAllRequest, submitRequest } = useAPI();

    const loadData = async () => {
        try {
            const [adminData, clientsData, tasksData] = await Promise.all([
                getAllAdmin(),
                getAllClients(),
                getAllRequest()
            ]);

            setAdmin(adminData);
            setClients(clientsData);
            setTasks(tasksData);
        } catch (error) {
            console.error("Error loading data:", error);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const validate = () => {
        const newErrors = {};
        if (!formData.clientId) newErrors.client = "Client is required";
        if (!formData.taskTitle) newErrors.taskTitle = "Task title is required";
        if (!formData.managerId) newErrors.managerId = "Manager is required";
        if (!formData.totalPages) newErrors.totalPages = "Total pages is required";
        if (files.length === 0) newErrors.files = "Document is required";
        return newErrors;
    };

    const handleSubmit = async () => {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoading(true);

        try {
            const deliveryDate = new Date(formData.deliveryDate).toISOString();
            const requestDate = new Date(formData.requestDate).toISOString();
            const requestData = {
                ...formData,
                clientId: Number(formData.clientId),
                managerId: Number(formData.managerId),
                totalPages: Number(formData.totalPages),
                taskTitle: formData.taskTitle,
                deliveryDate: deliveryDate,
                requestDate: requestDate,
            };

            const newRequest = await submitRequest(requestData);

            for (let i = 0; i < files.length; i++) {
                const formDataObj = new FormData();
                formDataObj.append("file", files[i]);
                await axios.post(
                    `${API_BASE_URL}/translate/docs?requestId=${newRequest?.data?.id}`,
                    formDataObj,
                    { headers: getAuthHeaders() }
                );
            }

            setLoading(false);
            resetForm();
            showSuccessMessage('Created new request successfully');
            await loadData();
        } catch (err) {
            console.error("Error submitting request:", err);
            setLoading(false);
        }
    };

    const resetForm = () => {
        setFormData(INITIAL_FORM_DATA);
        setFiles([]);
        setErrors({});
        setOpen(false);
    };

    const showSuccessMessage = (message) => {
        setSuccessMessage(message);
        setTimeout(() => {
            setSuccessMessage('');
        }, 3000);
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFiles(prevFiles => [...prevFiles, ...selectedFiles]);
        e.target.value = '';
    };

    const removeFile = (indexToRemove) => {
        setFiles(prevFiles => prevFiles.filter((_, index) => index !== indexToRemove));
    };

    const handleFilterClick = (filter) => {
        setOpenFilter(openFilter === filter ? null : filter);
    };

    const handleOptionSelect = (filter, value) => {
        setSelectedValues(prev => ({
            ...prev,
            [filter]: value
        }));
        setOpenFilter(null);
    };

    const handleClickOutside = (e) => {
        if (!e.target.closest('.filter-box')) {
            setOpenFilter(null);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    const getFilteredTasks = () => {
        let filtered = [...tasks];

        Object.keys(selectedValues).forEach((key) => {
            const value = selectedValues[key];
            if (value) {
                switch (key) {
                    case "Client":
                        filtered = filtered.filter((task) => task.clientName === value);
                        break;
                    case "Translator":
                        filtered = filtered.filter((task) => task.translatorName === value);
                        break;
                    case "Proofreader":
                        filtered = filtered.filter((task) => task.proofreaderName === value);
                        break;
                    case "Status":
                        filtered = filtered.filter((task) => task.status === value);
                        break;
                    default:
                        break;
                }
            }
        });

        return filtered;
    };

    const filteredTasks = getFilteredTasks();
    const filterData = {
        "Client": clients.map(client => `${client.firstName} ${client.lastName}`),
        "Translator": admin.map(member => `${member.firstName} ${member.lastName}`),
        "Proofreader": admin.map(member => `${member.firstName} ${member.lastName}`),
        "Status": ["UNASSIGNED", "TRANSLATING", "PROOFREADING", "STAMPING", 'COMPLETED']
    };
    return (
        <>
            <div className='requests'>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <h2 className="requests-title">Requests Management</h2>
                    <button className="new-request" onClick={() => setOpen(true)}>
                        New Request <EastIcon style={{ fontSize: "18px" }} />
                    </button>
                </Box>

                <div className="filters-wrapper">
                    <div className="filters-container">
                        {FILTER_TYPES.map((filter, index) => (
                            <FilterDropdown
                                key={index}
                                filter={filter}
                                selectedValue={selectedValues[filter]}
                                options={filterData[filter]}
                                isOpen={openFilter === filter}
                                onClick={handleFilterClick}
                                onSelect={handleOptionSelect}
                            />
                        ))}
                    </div>
                </div>

                <div>
                    {filteredTasks.length === 0 ? (
                        <div style={{
                            textAlign: 'center',
                            padding: '40px',
                            margin: '40px 0',
                            color: '#666',
                            fontSize: '18px',
                        }}>
                            <p>No data based on your search</p>
                        </div>
                    ) : (
                        filteredTasks.map((task) => (
                            <TaskCard key={task.id} task={task} onUpdate={loadData} onDelete={loadData} />
                        ))
                    )}
                </div>

                {successMessage && (
                    <div className="popup-message">
                        {successMessage}
                    </div>
                )}
            </div>

            <NewRequestModal
                isOpen={open}
                onClose={resetForm}
                formData={formData}
                onFormChange={setFormData}
                clients={clients}
                admin={admin}
                loading={loading}
                files={files}
                onFileChange={handleFileChange}
                onRemoveFile={removeFile}
                onSubmit={handleSubmit}
                errors={errors}
            />
        </>
    );
};

export default Request;